import React from "react";
import styled from "styled-components";

import Button from "partials/Button";
import Spinner from "icons/SpinnerNegIcon";

import Media from "css/Media";

export const LoadingButton = (props) => {
  return (
    <StyledButton negative={props.negative} className={props.className}>
      <p>{props.placeholder}</p>
      <Spinner fill={props.fill} />
    </StyledButton>
  );
};

export default LoadingButton;

const StyledButton = styled(Button)`
  height: 44px;
  min-width: 61.46px;
  p {
    font-size: 14px;
    line-height: 18.2px;
    color: ${(props) =>
      props.negative ? props.theme.colors.negative : props.theme.colors.button};
    transition: color 0.2s ease;
  }
  &:hover {
    p {
      color: ${(props) =>
        props.negative ? props.theme.colors.button : props.theme.colors.link};
    }
  }
  svg {
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  ${Media.greaterThan("s")`
    min-height: 70.2px;
  `}
`;
